import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { CmsFooterContactsProperties } from '../Models/CmsFooterContactsProperties';
import { CmsFooterSitemapProperties } from '../Models/CmsFooterContactsProperties';
import { CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLogoProperties, CmsLoginHeaderProperties, GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { CmsLoginDealsProperties, GroupTicketShowRightCMS } from '../Models/CmsLoginDealsProperties';
import { CmsContactUsProperties, NewsAlertProperties, NotificationProperties } from '../Models/CmsContactUsProperties';
import { CmsAboutUsLandingProperties, CmsAboutUsServicesProperties, CmsAboutUsTimelineProperties } from '../Models/CmsAboutUsProperties';
import { LoginUserProperties } from '../Models/UsersProperties';
import {  PrivacyPolicyProperties, TermsOfUseProperties } from '../Models/CmsFooterContactsProperties';
import { LoginSliderImagesProperties } from '../Models/LoginSliderImagesProperties';
import { InsuranceTypesSwitchProps } from '../Models/TravelInsuranceProperties';

@Injectable({
  providedIn: 'root'
})
export class CMSService {
  baseUrl = environment.baseUrl;
  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject(false);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

  //send() { //////console.log (footerObj); }

  userLoginEmail(emailObj): Observable<LoginUserProperties> {
    return this.http.post<LoginUserProperties>(this.baseUrl + '/CmsLogin/UserLoginEmail/', emailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  emailOTP(emailTo: string): Observable<LoginUserProperties> {
    return this.http.get<LoginUserProperties>(this.baseUrl + '/CmsLogin/EmailOTP/' + emailTo).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  //emailOTPVerify(emailVerifyObj): Observable<boolean> {
  //  return this.http.post<boolean>(this.baseUrl + '/CmsLogin/VerifyEmail/', emailVerifyObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}
  emailOTPVerify(emailVerifyObj): Observable<boolean> {
    const httpOptions = {
      headers: this.httpOptions.headers.set('Skip-Interceptor', 'true')
    };

    return this.http
      .post<boolean>(this.baseUrl + '/Login/VerifyUserWithTK/', emailVerifyObj, httpOptions)
      .pipe(
        map((data: any) => data),
        catchError(error => throwError(error))
      );
  }
  createLogo(logoObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateLogo', logoObj).pipe(map((data: any) => {  return data; }), catchError(error => { return throwError(error); }))
  }
  updateLogo(logoObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateLogo', logoObj)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getLogo(): Observable<CmsLogoProperties[]> {
    return this.http.get<CmsLogoProperties[]>(this.baseUrl + '/CmsLogin/GetLogo')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getLogoById(sr: number): Observable<CmsLogoProperties[]> {
    return this.http.get<CmsLogoProperties[]>(this.baseUrl + '/CmsLogin/GetLogoById/' + sr)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createHeader(headerObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateHeader', headerObj, this.httpOptions).pipe(map((data: any) => {  return data; }), catchError(error => { return throwError(error); }))
  }
  updateHeader(headerObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateHeader', headerObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getHeader(): Observable<CmsLoginHeaderProperties[]> {
    return this.http.get<CmsLoginHeaderProperties[]>(this.baseUrl + '/CmsLogin/GetHeader')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getHeaderById(sr: number): Observable<CmsLoginHeaderProperties[]> {
    return this.http.get<CmsLoginHeaderProperties[]>(this.baseUrl + '/CmsLogin/GetHeaderById/' + sr)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteHeader(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/DeleteHeader', sr, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  createMainContent(contentObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateMainContent', contentObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateMainContent(contentObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateMainContent', contentObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getMainContent(): Observable<CmsLoginMainContentProperties[]> {
    return this.http.get<CmsLoginMainContentProperties[]>(this.baseUrl + '/CmsLogin/GetMainContent', this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getMainContentById(sr: number): Observable<CmsLoginMainContentProperties[]> {
    return this.http.get<CmsLoginMainContentProperties[]>(this.baseUrl + '/CmsLogin/GetMainContentById/' + sr)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteMainContent(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/DeleteMainContent', sr, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  createDeals(dealsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateDeals', dealsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateDeals(dealsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateDeals', dealsObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getDeals(): Observable<CmsLoginDealsProperties[]> {
    return this.http.get<CmsLoginDealsProperties[]>(this.baseUrl + '/CmsLogin/GetDeals')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getDealsById(sr: number): Observable<CmsLoginDealsProperties[]> {
    return this.http.get<CmsLoginDealsProperties[]>(this.baseUrl + '/CmsLogin/GetDealsById/' + sr)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteDeals(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/DeleteDeals', sr, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  createFooterContacts(footerContactsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateFooterContacts', footerContactsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateFooterContacts(footerContactsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateFooterContacts', footerContactsObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getFooterContacts(): Observable<CmsFooterContactsProperties[]> {
    return this.http.get<CmsFooterContactsProperties[]>(this.baseUrl + '/CmsLogin/GetFooterContacts')
      .pipe(map((data: any) => {
        //////console.log (data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getFooterContactsById(sr: number): Observable<CmsFooterContactsProperties[]> {
    return this.http.get<CmsFooterContactsProperties[]>(this.baseUrl + '/CmsLogin/GetFooterContactsById/' + sr)
      .pipe(map((data: any) => {
        //////console.log (data);
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  deleteFooterContacts(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/DeleteFooterContacts', sr, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createFooterSitemap(footerSitemapObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateFooterSitemap', footerSitemapObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateFooterSitmap(footerSitemapObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateFooterSitemap', footerSitemapObj, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getFooterSitemap(): Observable<CmsFooterSitemapProperties[]> {
    return this.http.get<CmsFooterSitemapProperties[]>(this.baseUrl + '/CmsLogin/GetFooterSitemap')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getFooterSitemapById(sr: number): Observable<CmsFooterSitemapProperties[]> {
    return this.http.get<CmsFooterSitemapProperties[]>(this.baseUrl + '/CmsLogin/GetFooterSitemapById/' + sr)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteFooterSitemap(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/DeleteFooterSitemap', sr, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createFooterSocial(footerSocialObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/CreateFooterSocial', footerSocialObj).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateFooterSocial(footerSocialObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateFooterSocial', footerSocialObj)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getFooterSocial(): Observable<CmsFooterSocialProperties[]> {
    return this.http.get<CmsFooterSocialProperties[]>(this.baseUrl + '/CmsLogin/GetFooterSocial')
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getFooterSocialById(sr: number): Observable<CmsFooterSocialProperties[]> {
    return this.http.get<CmsFooterSocialProperties[]>(this.baseUrl + '/CmsLogin/GetFooterSocialById/' + sr)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteFooterSocial(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/DeleteFooterSocial', sr, this.httpOptions)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createContactUs(contactUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsContactUs/CreateContactUsPage', contactUsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateContactUs(contactUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsContactUs/UpdateContactUsPage', contactUsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getContactUs(): Observable<CmsContactUsProperties[]> {
    return this.http.get<CmsContactUsProperties[]>(this.baseUrl + '/CmsContactUs/GetContactUsPage', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getContactUsById(id: number): Observable<CmsContactUsProperties[]> {
    return this.http.get<CmsContactUsProperties[]>(this.baseUrl + '/CmsContactUs/GetContactUsById/' + id)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  deleteContactUs(sr: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsContactUs/DeleteContactUsPage', sr, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createAboutUsLanding(contactUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/CreateAboutUsLanding', contactUsObj).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateAboutUsLanding(aboutUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/UpdateAboutUsLanding', aboutUsObj).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAboutUsLanding(): Observable<CmsAboutUsLandingProperties[]> {
    return this.http.get<CmsAboutUsLandingProperties[]>(this.baseUrl + '/CmsAboutUs/GetAboutUsLanding', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAboutUsLandingById(id: number): Observable<CmsAboutUsLandingProperties[]> {
    return this.http.get<CmsAboutUsLandingProperties[]>(this.baseUrl + '/CmsAboutUs/GetAboutUsLandingById/' + id)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteAboutUsLanding(id: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/DeleteAboutUsLanding', id, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createAboutUsServices(aboutUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/CreateAboutUsServices', aboutUsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateAboutUsServices(aboutUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/UpdateAboutUsServices', aboutUsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAboutUsServices(): Observable<CmsAboutUsServicesProperties[]> {
    return this.http.get<CmsAboutUsServicesProperties[]>(this.baseUrl + '/CmsAboutUs/GetAboutUsServices', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAboutUsServicesById(id: number): Observable<CmsAboutUsServicesProperties[]> {
    return this.http.get<CmsAboutUsServicesProperties[]>(this.baseUrl + '/CmsAboutUs/GetAboutUsServicesById/' + id)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteAboutUsServices(id: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/DeleteAboutUsServices', id, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  createAboutUsTimeline(aboutUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/CreateAboutUsTimeline', aboutUsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateAboutUsTimeline(aboutUsObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/UpdateAboutUsTimeline', aboutUsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAboutUsTimeline(): Observable<CmsAboutUsTimelineProperties[]> {
    return this.http.get<CmsAboutUsTimelineProperties[]>(this.baseUrl + '/CmsAboutUs/GetAboutUsTimeline', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getAboutUsTimelineById(id: number): Observable<CmsAboutUsTimelineProperties[]> {
    return this.http.get<CmsAboutUsTimelineProperties[]>(this.baseUrl + '/CmsAboutUs/GetAboutUsTimelineById/' + id)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteAboutUsTimeline(id: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsAboutUs/DeleteAboutUsTimeline', id, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  //getAllLoginPageData(): Observable<GetAllCmsLoginProperties> {
  //  return this.http.get<GetAllCmsLoginProperties>(this.baseUrl + '/CmsLogin/GetAllLoginData', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  //}

  getAllLoginPageData(): Observable<GetAllCmsLoginProperties> {
    this.showSpinner.next(true);
    return this.http.get<GetAllCmsLoginProperties>(this.baseUrl + '/CmsLogin/GetAllLoginData', this.httpOptions).pipe(tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false)
    ));
    
  }
  CheckRightsAgaintAgencyAndUserId(agencyId, userId): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/CmsLogin/CheckRightAgainstAgencyAndUserId/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => {
        //////console.log (error);
        return throwError(error);
      }))
  }
  addNews(newsObj: NewsAlertProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/AddNews', newsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateNews(newsObj: NewsAlertProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateNews', newsObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteNews(newsId: string): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/CmsLogin/DeleteNews/' + newsId).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getActiveNews(): Observable<NewsAlertProperties[]> {
    return this.http.get<NewsAlertProperties[]>(this.baseUrl + '/CmsLogin/GetActiveNews', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getNewsById(newsId: string): Observable<NewsAlertProperties> {
    return this.http.get<NewsAlertProperties>(this.baseUrl + '/CmsLogin/GetNewsById/' + newsId)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  addNotification(notiObj: NotificationProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/AddNotification', notiObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updateNotification(notiObj: NotificationProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateNotification', notiObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  deleteNotification(notiId: string): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/CmsLogin/DeleteNotification/' + notiId).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getActiveNotification(): Observable<NotificationProperties[]> {
    return this.http.get<NotificationProperties[]>(this.baseUrl + '/CmsLogin/GetActiveNotification', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getNotificationById(notiId: string): Observable<NotificationProperties> {
    return this.http.get<NotificationProperties>(this.baseUrl + '/CmsLogin/GetNotificationById/' + notiId).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  UpdateNewUserPassword(updateuserpassObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdatePasswordofNewUser', updateuserpassObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  //forgot services:
  UserFogotEmail(emailObj): Observable<LoginUserProperties> {
    return this.http.post<LoginUserProperties>(this.baseUrl + '/CmsLogin/UserFogotEmail/', emailObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ForgotemailOTP(emailTo: string): Observable<LoginUserProperties> {
    return this.http.get<LoginUserProperties>(this.baseUrl + '/CmsLogin/EmailOTP/' + emailTo).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ForgotemailOTPVerify(emailVerifyObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/VerifyForgotEmail/', emailVerifyObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ForgotResetPassword(forgotpassObj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/ForgotResetPassword', forgotpassObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getFooterData(): Observable<GetAllCmsLoginProperties> {
    return this.http.get<GetAllCmsLoginProperties>(this.baseUrl + '/CmsLogin/GetFooterData', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getPrivacyPolicy(): Observable<PrivacyPolicyProperties> {
    return this.http.get<PrivacyPolicyProperties>(this.baseUrl + '/CmsLogin/GetPrivacyPolicy').pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  updatePrivacyPolicy(privacyUpdateObj: PrivacyPolicyProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdatePrivacyPolicy', privacyUpdateObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  updateTerms(termsUpdateObj: TermsOfUseProperties): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateTermsOfUse', termsUpdateObj, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  getTermsOfUse(): Observable<TermsOfUseProperties> {
    return this.http.get<TermsOfUseProperties>(this.baseUrl + '/CmsLogin/GetTermsOfUse').pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  ChangeGroupTicketStatus(groupTicketShowRightCMS:GroupTicketShowRightCMS): Observable<boolean> {
    return this.http.post<TermsOfUseProperties>(this.baseUrl + '/CmsLogin/ChangeGroupTicketStatus',groupTicketShowRightCMS).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  GetGroupTicketRight(): Observable<GroupTicketShowRightCMS> {
    return this.http.get<GroupTicketShowRightCMS>(this.baseUrl + '/CmsLogin/GetGroupTicketRight').pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }


  getLoginSliderImges(): Observable<LoginSliderImagesProperties[]> {
    return this.http.get<LoginSliderImagesProperties[]>(this.baseUrl + '/LoginSlider/GetLoginSliderImages').pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))

  }
  DeleteSliderImage(Id: number): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/LoginSlider/DeleteLoginSliderImage/' + Id, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))

  }
  UpdateSliderImage(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/LoginSlider/UpdateSliderImage', obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  CreateSliderImage(obj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/LoginSlider/CreateSliderImages', obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateInsuranceTypesStatus(insuranceOption: InsuranceTypesSwitchProps[]): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CmsLogin/UpdateInsuranceTypesStatus', insuranceOption, this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  GetInsuranceTypesStatus(): Observable<InsuranceTypesSwitchProps[]> {
    return this.http.get<InsuranceTypesSwitchProps[]>(this.baseUrl + '/CmsLogin/GetInsuranceTypesStatus', this.httpOptions).pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }
  private refreshInsuranceDataSource = new BehaviorSubject<boolean>(false);
  refreshInsuranceData$ = this.refreshInsuranceDataSource.asObservable();
  // Method to trigger data refresh
  triggerInsuranceNavRefresh() {
    this.refreshInsuranceDataSource.next(true);
  }
}
